import { required, email, confirmed, min, max, length } from 'vee-validate/dist/rules';
import { extend } from 'vee-validate';
import { rutValidator } from 'vue-dni';
import i18n from '@/languages';


extend('required', {
  ...required,
  message: i18n.t('form.validation.messages.required'),
});

extend('email', {
  ...email,
  message: (_, values) => i18n.t('form.validation.messages.email', values),
})

extend('confirmed', {
  ...confirmed,
  message: (_, values) => i18n.t('form.validation.messages.confirmed', values),
});

extend('min', {
  ...min,
  message: i18n.t('form.validation.messages.min'),
})

extend('max', {
  ...max,
  message: i18n.t('form.validation.messages.max'),
})

extend('length', {
  ...length,
  message: i18n.t('form.validation.messages.length'),
})

// TODO: Exclude 0 without activate validation on form load
extend('positive-money', {
  validate(value) {
    value = typeof value === 'string' ? parseInt(value.replace('$ ', '').replace(/\./, '')) : value;
    return value >= 0;
  },
  message: 'El monto ingresado no es válido.'
});

extend('rut', {
  validate: rutValidator,
  message: 'El rut ingresado no es válido.'
  }
);

// Mismo largo que exige el backend (AUTH_PASSWORD_VALIDATORS + el max_length
// del signup). Mensaje fijo: los <Input> no nombran el campo, y el `min`
// genérico diría "El campo {_field_}…".
export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 64;

extend('password_length', {
  validate: (value) => {
    const size = String(value || '').length;
    return size >= PASSWORD_MIN_LENGTH && size <= PASSWORD_MAX_LENGTH;
  },
  message: `La contraseña debe tener entre ${PASSWORD_MIN_LENGTH} y ${PASSWORD_MAX_LENGTH} caracteres.`,
});
